import { render, staticRenderFns } from "./CustomerListByPurchasedProduct.vue?vue&type=template&id=78ec3cb5&scoped=true"
import script from "./CustomerListByPurchasedProduct.vue?vue&type=script&lang=js"
export * from "./CustomerListByPurchasedProduct.vue?vue&type=script&lang=js"
import style0 from "./CustomerListByPurchasedProduct.vue?vue&type=style&index=0&id=78ec3cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec3cb5",
  null
  
)

export default component.exports